export const formatNumber = (number, dec = 2) => {
    number = parseFloat(number).toFixed(dec)
    return  Number(number).toLocaleString('en');
};
